import React from 'react'
import { Modal } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../routes/CustomRoutes';
import { URL_AUTH } from '../../constants/urls';
import { GET } from '../../frameworks/HttpClient';
import { useUserContext } from '../../hooks/UserSettingProvider';
import Cookies from 'js-cookie';

export default function LogoutModal({ open= false, onClose = () => {}, isLiff= false}) {
	const navigate = useNavigate();
	const user = useUserContext();

	const handleLogout = async () => {
		try {
			await GET(URL_AUTH.SIGN_OUT)
		} catch (error) {}
		finally {
			user.onLogout();
			navigate(PATH.LOGIN);
			onClose();
			Cookies.remove('id');
		}
	}

	return (
		<Modal 
			title={"ออกจากระบบ"}
			okText={"ตกลง"}
			cancelText={"ยกเลิก"}
			centered={false}
			icon={<LogoutOutlined />}
			open={open}
			onOk={handleLogout}
			onCancel={onClose}>
				
				<p>{"คุณต้องการที่จะออกจากระบบใช่หรือไม่ ?"}</p>
		</Modal>
	)
}